import {
  BarChart3,
  Banknote,
  Briefcase,
  Code,
  FolderKanban,
  GraduationCap,
  Headphones,
  Megaphone,
  Palette,
  Shield,
  TrendingUp,
  Users,
  type LucideIcon,
} from 'lucide-react'

export const VACANCY_ICON_MAP: Record<string, LucideIcon> = {
  'Информационные технологии': Code,
  'Дизайн': Palette,
  'Маркетинг': Megaphone,
  'Продажи': TrendingUp,
  'Финансы': Banknote,
  'Управление проектами': FolderKanban,
  'HR и рекрутинг': Users,
  'Клиентский сервис': Headphones,
  'Аналитика': BarChart3,
  'Кибербезопасность': Shield,
  'Образование': GraduationCap,
  'Другое': Briefcase,
}

export const VACANCY_BACKGROUND_MAP: Record<
  string,
  { image: string; gradient: string }
> = {
  'Информационные технологии': {
    image: '/vacancy-backgrounds/it.jpg',
    gradient: 'linear-gradient(135deg, rgba(37,99,235,0.86), rgba(15,23,42,0.9))',
  },
  'Дизайн': {
    image: '/vacancy-backgrounds/design.jpg',
    gradient: 'linear-gradient(135deg, rgba(217,70,239,0.82), rgba(91,33,182,0.88))',
  },
  'Маркетинг': {
    image: '/vacancy-backgrounds/marketing.jpg',
    gradient: 'linear-gradient(135deg, rgba(249,115,22,0.85), rgba(190,24,93,0.88))',
  },
  'Продажи': {
    image: '/vacancy-backgrounds/sales.jpg',
    gradient: 'linear-gradient(135deg, rgba(34,197,94,0.82), rgba(6,95,70,0.9))',
  },
  'Финансы': {
    image: '/vacancy-backgrounds/finance.jpg',
    gradient: 'linear-gradient(135deg, rgba(20,83,45,0.84), rgba(17,24,39,0.9))',
  },
  'Управление проектами': {
    image: '/vacancy-backgrounds/project-management.jpg',
    gradient: 'linear-gradient(135deg, rgba(8,145,178,0.84), rgba(30,41,59,0.9))',
  },
  'HR и рекрутинг': {
    image: '/vacancy-backgrounds/hr.jpg',
    gradient: 'linear-gradient(135deg, rgba(236,72,153,0.82), rgba(88,28,135,0.88))',
  },
  'Клиентский сервис': {
    image: '/vacancy-backgrounds/customer-support.jpg',
    gradient: 'linear-gradient(135deg, rgba(14,165,233,0.82), rgba(30,64,175,0.88))',
  },
  'Аналитика': {
    image: '/vacancy-backgrounds/analytics.jpg',
    gradient: 'linear-gradient(135deg, rgba(99,102,241,0.84), rgba(31,41,55,0.9))',
  },
  'Кибербезопасность': {
    image: '/vacancy-backgrounds/security.jpg',
    gradient: 'linear-gradient(135deg, rgba(15,23,42,0.88), rgba(2,132,199,0.84))',
  },
  'Образование': {
    image: '/vacancy-backgrounds/education.jpg',
    gradient: 'linear-gradient(135deg, rgba(245,158,11,0.82), rgba(180,83,9,0.88))',
  },
  'Другое': {
    image: '/vacancy-backgrounds/other.jpg',
    gradient: 'linear-gradient(135deg, rgba(71,85,105,0.84), rgba(30,41,59,0.9))',
  },
};

export const VACANCY_CATEGORIES = Object.keys(VACANCY_BACKGROUND_MAP);

export function getVacancyBackground(category?: string) {
  return (
    (category && VACANCY_BACKGROUND_MAP[category]) || {
      image: '',
      gradient: 'linear-gradient(135deg, rgba(37,99,235,0.08), rgba(168,85,247,0.08))',
    }
  );
}

export function getVacancyIcon(category?: string): LucideIcon {
  return (category && VACANCY_ICON_MAP[category]) || Briefcase;
}
